import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '@/contexts/AuthContext';

export const useAuth = () => {
  const navigate = useNavigate();
  const { user, session, loading, initialized, signIn, signUp, signOut: contextSignOut } = useAuthContext();

  const signOut = async () => {
    const { error } = await contextSignOut();
    if (!error) {
      navigate('/');
    }
    return { error };
  };

  return {
    user,
    session,
    loading,
    initialized,
    signIn,
    signUp,
    signOut,
  };
};
